export function LinkedDocumentIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3337 6.0091V9.33717H12.0003V6.67051H8.66699C8.2988 6.67051 8.00033 6.37203 8.00033 6.00384V2.67051H4.66699C4.2988 2.67051 4.00033 2.96898 4.00033 3.33717V14.5567C3.22353 14.2821 2.66699 13.5413 2.66699 12.6705V3.33717C2.66699 2.2326 3.56242 1.33717 4.66699 1.33717H8.66175L13.3337 6.0091ZM9.33366 5.33717V3.61332L11.0575 5.33717H9.33366Z"
        fill="currentColor"
      />
      <path
        d="M10.667 8.67051C10.667 9.0387 10.3685 9.33717 10.0003 9.33717H6.00033C5.63214 9.33717 5.33366 9.0387 5.33366 8.67051C5.33366 8.30232 5.63214 8.00384 6.00033 8.00384H10.0003C10.3685 8.00384 10.667 8.30232 10.667 8.67051Z"
        fill="currentColor"
      />
      <path
        d="M7.33366 10.0038C5.8609 10.0038 4.66699 11.1977 4.66699 12.6705C4.66699 14.1433 5.8609 15.3372 7.33366 15.3372H8.00033C8.36851 15.3372 8.66699 15.0387 8.66699 14.6705C8.66699 14.3023 8.36851 14.0038 8.00033 14.0038H7.33366C6.59728 14.0038 6.00033 13.4069 6.00033 12.6705C6.00033 11.9341 6.59728 11.3372 7.33366 11.3372H8.00033C8.36851 11.3372 8.66699 11.0387 8.66699 10.6705C8.66699 10.3023 8.36851 10.0038 8.00033 10.0038H7.33366Z"
        fill="currentColor"
      />
      <path
        d="M10.667 10.0038C10.2988 10.0038 10.0003 10.3023 10.0003 10.6705C10.0003 11.0387 10.2988 11.3372 10.667 11.3372H11.3337C12.07 11.3372 12.667 11.9341 12.667 12.6705C12.667 13.4069 12.07 14.0038 11.3337 14.0038H10.667C10.2988 14.0038 10.0003 14.3023 10.0003 14.6705C10.0003 15.0387 10.2988 15.3372 10.667 15.3372H11.3337C12.8064 15.3372 14.0003 14.1433 14.0003 12.6705C14.0003 11.1977 12.8064 10.0038 11.3337 10.0038H10.667Z"
        fill="currentColor"
      />
      <path
        d="M7.33366 12.6705C7.33366 12.3023 7.63214 12.0038 8.00033 12.0038H10.667C11.0352 12.0038 11.3337 12.3023 11.3337 12.6705C11.3337 13.0387 11.0352 13.3372 10.667 13.3372H8.00033C7.63214 13.3372 7.33366 13.0387 7.33366 12.6705Z"
        fill="currentColor"
      />
    </svg>
  );
}
